import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './Footer.scss';

const Footer = (props) => {

    const navigate = useNavigate();
    const handleClickNextLesson = () => {
        let lesson = props.currentPreviewPage + 2;
        let goPage = '/lesson-' + lesson;
        navigate(goPage);
    }

    const handleClickPreviousLesson = () => {
        let lesson = props.currentPreviewPage;
        let goPage = '/lesson-' + lesson;
        // console.log(lesson);

        if (lesson == 1) {
            navigate('/');
        } else {
            navigate(goPage);
        }

       
    }

    return (
        <div className='sticky-bottom bg-white py-2'>
            <div className='row d-flex'>
                <div className='col-6 border-end text-end'>
                    <button
                        id='btn--previous'
                        disabled={props.currentPreviewPage == 0}
                        className='border-0 bg-white texto--footer ps-3 ps-xl-3'
                        onClick={handleClickPreviousLesson}
                    // onClick={() => setSelectedTab(selectedTab - 1)}
                    // disabled={selectedTab <= 0}
                    >
                        <FaChevronUp className='me-2' />
                        {props.previousLessonName}
                    </button>
                </div>

                <div className='col-6'>
                    <button
                        id='btn--next'
                        disabled={props.currentPreviewPage == 14}
                        className='border-0 bg-white texto--footer'
                        onClick={handleClickNextLesson}
                    // onClick={() => setSelectedTab(selectedTab + 1)}
                    // disabled={selectedTab > data.length - 1}
                    >
                        <FaChevronDown className='me-2' />
                        {props.nextLessonName}
                    </button>
                </div>
            </div>
        </div>
    );

}

export default Footer;